<script setup lang="ts">
// https://www.radix-vue.com/components/popover.html

defineProps<{
  text?: string
}>();

defineSlots<{
  default: () => unknown
}>();

const modelValue = defineModel<boolean>({ default: false });

// Horrible fix to prevent hydration issues
const isMounted = useMounted();
</script>

<template>
  <div class="contents">
    <IadBtn
      v-if="!isMounted"
      variant="outlined"
      :text
      tag="div"
    />
    <PopoverRoot
      v-else
      v-model:open="modelValue"
      modal
    >
      <PopoverAnchor as-child>
        <PopoverTrigger>
          <IadBtn
            variant="outlined"
            :text
            tag="div"
          />
        </PopoverTrigger>
      </PopoverAnchor>
      <PopoverContent
        :side-offset="10"
        align="start"
        class="p-m w-[500px]
            rounded-md bg-white ring-1 ring-neutral-60 shadow-popover
            will-change-[transform,opacity] data-[state=open]:animate-slideDownAndFade"
        position-strategy="absolute"
      >
        <PopoverClose class="pb-m">
          <IadBtn
            icon
            variant="outlined"
          >
            <Icon name="iad-icon:close" />
          </IadBtn>
        </PopoverClose>
        <slot />
      </PopoverContent>
    </PopoverRoot>
  </div>
</template>
